import styles from './style.postcss';

import classnames from 'classnames';
import is from 'is_js';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, PageCard, Icon, moment } from 'omni-common-ui';
import AddInternalNoteControl from 'components/AddInternalNoteControl';
import CardActionIcons from 'components/CardActionIcons';
import UserCard from 'components/UserCard';
import {
  accessors as writingAssignmentOverview,
} from 'data/WritingAssignment';

const COMPLETED = 'CO';
const YES = 'YES';
const NO = 'NO';

class IndividualCard extends PureComponent {

  _onExpansionButtonClick() {
    const { isExpand } = this.state;
    this.setState({
      isExpand: ! isExpand,
    });
  }

  _onEdit() {
    this.setState({
      isExpand: true,
    });
    this.props.onEdit();
  }

  _isCompleted(status) {
    return status === COMPLETED;
  }

  _renderEssayHeader() {
    const { writing, isEdit, type, canEdit } = this.props;
    const { name, status } = writing;
    const headerInstruction = `${name}, ${type}`;
    return <div className={styles.TextEditor_essay_header}>
      <h1 className={styles.TextEditor_essay_header_title}>
        {headerInstruction}
      </h1>
      {(isEdit || this._isCompleted(status) || ! canEdit) ? null :
        (<CardActionIcons onEditClick={() => this._onEdit()}
            hideDeleteIcon />)}
    </div>;
  }

  _renderEssay() {
    const { writing, isEdit } = this.props;
    const className = classnames({ [styles.TextEditor_essay_scrollable]: isEdit });
    return <div className={styles.TextEditor_essay}>
      <p className={className}
        // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={this._createMarkUp(writing.essay)} />
    </div>;
  }

  _renderOption(questionNo, checked, type) {
    const { isEdit } = this.props;
    const bgClass = classnames(styles.TextEditor_shortAnswer_row_options_radio, {
      [styles.__correctSelectBG]: checked && type === YES,
      [styles.__inCorrectSelectBG]: checked && type === NO,
      [styles.__disable]: ! isEdit,
    });
    const iconClass = classnames(styles.__icon, {
      [styles.__disable]: ! isEdit,
    });
    return <div className={bgClass}
        onClick={() => isEdit && this._onShortAnswersUpdate(questionNo, type === YES)}>
      {
        type === YES ?
          <Icon id="tick" className={iconClass} /> : <Icon id="cross" className={iconClass} />
      }
    </div>;
  }

  _renderShortAnswer() {
    const { isEdit, writing, shortAnswers } = this.props;
    const shortAnswerList = isEdit ? shortAnswers : writing.shortAnswers;

    if (shortAnswerList && shortAnswerList.size > 0) {
      return <div className={styles.TextEditor_shortAnswer}>
        <div className={classnames(styles.TextEditor_shortAnswer_row,
          styles.TextEditor_shortAnswer_row_header)}>
          <div className={styles.TextEditor_shortAnswer_row_content}>
            <h4>Short Answers</h4>
          </div>
          <div className={styles.TextEditor_shortAnswer_row_content}>
            <h4>Result</h4>
          </div>
        </div>
        {shortAnswerList.map((item) => <div className={styles.TextEditor_shortAnswer_row}>
          <div className={styles.TextEditor_shortAnswer_row_content}>
            <h4 className={styles.TextEditor_shortAnswer_row_question}
              // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={this._createMarkUp(`Q${item.questionNo}: ${item.question}`)} />
            <div className={styles.TextEditor_shortAnswer_row_answer}>
              {item.studentAnswer}
            </div>
          </div>
          <div className={styles.TextEditor_shortAnswer_row_options}>
            {this._renderOption(
              item.questionNo,
              is.boolean(item.isCorrect) && item.isCorrect,
              YES,
            )}
            {this._renderOption(
              item.questionNo,
              is.boolean(item.isCorrect) && ! item.isCorrect,
              NO,
            )}
          </div>
        </div>)}
      </div>;
    }
    return null;
  }

  _renderComment(isShortAnswer) {
    if (this.props.isEdit) {
      return this._renderCommentForm(isShortAnswer);
    }
    return isShortAnswer ? null : this._renderCommentView();
  }

  _onShortAnswersUpdate(questionNo, isCorrect) {
    const { shortAnswers, isEdit } = this.props;
    if (! isEdit) return false;
    const result = shortAnswers.map((shortAnswer) => {
      if (shortAnswer.questionNo === questionNo) {
        return shortAnswer.set('isCorrect', isCorrect);
      }
      return shortAnswer;
    });
    this.props.onShortAnswersUpdate(result);
  }

  _createMarkUp(html) {
    return {
      __html: html,
    };
  }

  _isSaveButtonDisable(type, comment, shortAnswers) {
    if (comment && is.string(comment) && comment.trim()) {
      return false;
    }
    if (writingAssignmentOverview.isShortAnswer(type) &&
      shortAnswers && shortAnswers.some(({ isCorrect }) => is.boolean(isCorrect))) {
      return false;
    }
    return true;
  }

  _renderCommentForm(isShortAnswer) {
    const {
      onSaveComment,
      onDiscardComment,
      comment,
      shortAnswers,
      onCommentUpdate,
      type,
    } = this.props;
    this._isSaveButtonDisable = this._isSaveButtonDisable.bind(this);
    if (isShortAnswer) {
      return <div className={styles.TextEditor_comment}>
        <Button.Container align="right">
          <Button type={Button.Type.primary}
              disabled={this._isSaveButtonDisable(type, comment, shortAnswers)}
              onClick={() => onSaveComment()}>
            SAVE
          </Button>
          <Button type={Button.Type.default}
              onClick={onDiscardComment}>
            DISCARD
          </Button>
        </Button.Container>
      </div>;
    }
    return <div className={styles.TextEditor_comment}>
      <h4>Teacher's feedback</h4>
      <AddInternalNoteControl text={comment}
          noAutoScroll={writingAssignmentOverview.isShortAnswer(type)}
          maxCharacters={2000}
          onChange={(text) => onCommentUpdate(text)} />
      <Button.Container align="right">
        <Button type={Button.Type.primary}
            disabled={this._isSaveButtonDisable(type, comment, shortAnswers)}
            onClick={() => onSaveComment()}>
          SAVE
        </Button>
        <Button type={Button.Type.default}
            onClick={onDiscardComment}>
          DISCARD
        </Button>
      </Button.Container>
    </div>;
  }

  _renderCommentView() {
    const { comment, commentBy, commentDate } = this.props.writing;
    if (is.existy(comment) && comment.length > 0) {
      return <div className={styles.TextEditor_comment}>
        <UserCard id={`${commentBy}`}
            dateStr={this._transformDate(commentDate)} />
        <p>{comment}</p>
      </div>;
    }
    return null;
  }

  _transformDate(date) {
    if (! date) return '';
    return moment.utc(date).clone().tz(this.props.timeZone).format('YYYY-MM-DD');
  }

  _renderSubmitDate(writing) {
    return <aside className={styles.TextEditor_date}>
      Submitted on {this._transformDate(writing.submitDate)}
    </aside>;
  }

  render() {
    const { writing, type } = this.props;
    if (is.existy(writing)) {
      return <PageCard>
        <PageCard.Heading>
          {this._renderEssayHeader()}
        </PageCard.Heading>
        <PageCard.Content className={styles.TextEditor_content_container}>
          {writingAssignmentOverview.isShortAnswer(type) ?
            this._renderShortAnswer() : this._renderEssay(writing)}
          {this._renderSubmitDate(writing)}
          {this._renderComment(writingAssignmentOverview.isShortAnswer(type))}
        </PageCard.Content>
      </PageCard>;
    }
    return null;
  }
}

IndividualCard.propTypes = {
  type: PropTypes.string,
  writing: PropTypes.object,
  isEdit: PropTypes.bool,
  onEdit: PropTypes.func,
  onDiscardComment: PropTypes.func,
  onSaveComment: PropTypes.func,
  comment: PropTypes.string,
  shortAnswers: PropTypes.object,
  onCommentUpdate: PropTypes.func,
  onShortAnswersUpdate: PropTypes.func,
  timeZone: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
};

export default IndividualCard;



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/StudentWritingAssignment/IndividualCard/index.jsx